var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportIssue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ReportIssue_Icon",
    "data-name": "ReportIssue Icon",
    transform: "translate(-16.97 -18.026)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(17.72 18.776)",
    fill: "#fff",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2684",
    "data-name": "Group 2684",
    transform: "translate(29.615 28.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M70.331,70.579H41.249a6.037,6.037,0,0,1-5.225-9.055L50.565,36.338a6.032,6.032,0,0,1,10.45,0L75.556,61.524a6.037,6.037,0,0,1-5.225,9.055ZM55.79,34.269a5.028,5.028,0,0,0-4.4,2.544L36.845,62a5.087,5.087,0,0,0,4.4,7.631H70.331A5.087,5.087,0,0,0,74.735,62L60.194,36.813A5.033,5.033,0,0,0,55.79,34.269Z",
    transform: "translate(-35.205 -33.32)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M76.247,66.11,61.706,40.925a3.189,3.189,0,0,0-5.524,0L41.641,66.11A3.189,3.189,0,0,0,44.4,70.894H73.485A3.191,3.191,0,0,0,76.247,66.11ZM57.269,45.637H60.6a.7.7,0,0,1,.693.74l-.9,14.114a.7.7,0,0,1-.693.65H58.2a.7.7,0,0,1-.693-.65l-.93-14.114A.693.693,0,0,1,57.269,45.637ZM60.88,66.851a2.671,2.671,0,0,1-1.941.778,2.638,2.638,0,0,1-1.927-.778,2.539,2.539,0,0,1-.778-1.59,2.7,2.7,0,0,1,.987-2.368,2.661,2.661,0,0,1,1.718-.584,2.7,2.7,0,0,1,1.941.764,2.512,2.512,0,0,1,.793,1.884,2.558,2.558,0,0,1-.793,1.9Z",
    transform: "translate(-38.359 -36.478)",
    fill: "#a5551c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIssue);
export default __webpack_public_path__ + "static/media/ReportIssue.9b2e64ab528e5808c1b8147eb6c0b66f.svg";
export { ForwardRef as ReactComponent };